export enum ClientType
{
    Web = 1,
    App = 2,
    StandAlone = 3
}